import palette from 'constants/palette'
import React from 'react'

type Props = {
  className?: string
  strokeColor?: string
}

// Order-stage rail glyph: "preparing" (Live Updates Overview tab). Geometry is the
// Sketch prototype's own (live-updates-onboarding v31, `ICON2`), traced rather
// than approximated so the rail reads as one set.
const ChefHat = ({ className, strokeColor = palette.grey90 }: Props) => (
  <svg
    className={className}
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
    stroke={strokeColor}
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z" />
    <path d="M6 17h12" />
  </svg>
)

export default ChefHat
